import React from 'react';
import { 
  RadarChart, 
  PolarGrid, 
  PolarAngleAxis, 
  PolarRadiusAxis, 
  Radar, 
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Legend,
  Tooltip
} from 'recharts';

const EnergyCharts = ({ energyData }) => {
  if (!energyData) return null;

  // 五行数据处理
  const elementData = [
    { subject: '金', A: 0, fullMark: 100 },
    { subject: '木', A: 0, fullMark: 100 },
    { subject: '水', A: 0, fullMark: 100 },
    { subject: '火', A: 0, fullMark: 100 },
    { subject: '土', A: 0, fullMark: 100 },
  ];

  // 根据生日和姓名计算五行值
  if (energyData.elements) {
    if (energyData.elements.birth) {
      const { month, day } = energyData.elements.birth;
      elementData.forEach(item => {
        if (item.subject === month) item.A += 30;
        if (item.subject === day) item.A += 20;
      });
    }

    if (energyData.elements.name) {
      const nameElements = energyData.elements.name;
      Object.values(nameElements).forEach(element => {
        const elementItem = elementData.find(item => item.subject === element);
        if (elementItem) elementItem.A += 10;
      });
    }
  } else if (typeof energyData === 'object') {
    // 兼容旧格式数据
    Object.entries(energyData).forEach(([element, value]) => {
      const elementItem = elementData.find(item => item.subject === element);
      if (elementItem) elementItem.A = value;
    });
  }

  // 能量分布数据
  const energyDistribution = [
    { name: '情感', value: energyData.energy?.emotion || 0, color: '#FF6B6B' },
    { name: '事业', value: energyData.energy?.career || 0, color: '#4ECDC4' },
    { name: '健康', value: energyData.energy?.health || 0, color: '#FFD166' },
    { name: '财富', value: energyData.energy?.wealth || 0, color: '#6A0572' },
  ];

  // 饼图颜色
  const COLORS = energyDistribution.map(item => item.color);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      {/* 五行雷达图 */}
      <div className="card p-4">
        <h3 className="text-lg font-semibold mb-4 text-center">五行能量分析</h3>
        <div className="h-64 md:h-80">
          <ResponsiveContainer width="100%" height="100%">
            <RadarChart cx="50%" cy="50%" outerRadius="80%" data={elementData}>
              <PolarGrid />
              <PolarAngleAxis dataKey="subject" />
              <PolarRadiusAxis angle={90} domain={[0, 100]} />
              <Radar
                name="五行能量"
                dataKey="A"
                stroke="#A2A7F0"
                fill="#A2A7F0"
                fillOpacity={0.6}
              />
              <Tooltip />
            </RadarChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* 能量分布饼图 */}
      <div className="card p-4">
        <h3 className="text-lg font-semibold mb-4 text-center">能量分布</h3>
        <div className="h-64 md:h-80">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={energyDistribution}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
              >
                {energyDistribution.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip formatter={(value) => `${value}分`} />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default EnergyCharts;